class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.content) return;

    if (!this.animations) {
      this.animations =
        typeof this.content.getAnimations === 'function' ? this.content.getAnimations() : [];
    }

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation && animation.play && animation.play());
    } else {
      this.animations.forEach((animation) => animation && animation.cancel && animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '')
      return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

class CategoriesMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.init();
    window.addEventListener("resize", this.onResize.bind(this));
  }

  init() {
    this.isTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    this.linkLevels = this.querySelectorAll(".link-level");

    this.linkLevels.forEach((linkLevel) => {
      linkLevel.removeEventListener("mouseenter", this.onLinkLevelEnter);
      linkLevel.removeEventListener("mouseleave", this.onLinkLevelLeave);
      linkLevel.removeEventListener("click", this.onLinkLevelClick);
    });

    if (this.isTouch) {
      this.linkLevels.forEach((linkLevel) => {
        linkLevel.addEventListener("click", this.onLinkLevelClick.bind(this));
      });
    } else {
      this.mainDetailsToggle.addEventListener("mouseenter", this.onMouseEnter.bind(this));
      this.mainDetailsToggle.addEventListener("mouseleave", this.onMouseLeave.bind(this));

      if (this.content) {
        this.content.addEventListener("mouseenter", this.onMouseEnter.bind(this));
        this.content.addEventListener("mouseleave", this.onMouseLeave.bind(this));
      }

      this.linkLevels.forEach((linkLevel) => {
        linkLevel.addEventListener("mouseenter", this.onLinkLevelEnter.bind(this));
        linkLevel.addEventListener("mouseleave", this.onLinkLevelLeave.bind(this));
      });
    }
  }

  onResize() {
    this.init(); 
  }

  onMouseEnter() {
    this.mainDetailsToggle.setAttribute("open", "");
  }

  onMouseLeave() {
    setTimeout(() => {
      const hasFocus = this.contains(document.activeElement);
      const toggleHovered = this.mainDetailsToggle ? this.mainDetailsToggle.matches(":hover") : false;
      const contentHovered = this.content ? this.content.matches(":hover") : false;

      if (!hasFocus && !toggleHovered && !contentHovered) {
        this.mainDetailsToggle.removeAttribute("open");
      }
    }, 200);
  }

  onLinkLevelClick(event) {
    const firstLink = event.currentTarget.querySelector(".link");
    const firstLinkParent = firstLink ? firstLink.getAttribute("data-parent") : null;

    this.linkLevels.forEach((linkLevel) => {
      if (linkLevel !== event.currentTarget) {
        const link = linkLevel.querySelector(".link");
        const parent = link ? link.getAttribute("data-parent") : null;
        if (firstLinkParent && firstLinkParent === parent) {
          link && link.setAttribute("data-visible", "false");
        }
      }
    });

    if (firstLink) {
      firstLink.setAttribute("data-visible", "true");
    }
  }

  onLinkLevelEnter(event) {
    this.clearOtherVisibleLinks(event.currentTarget);
    const firstLink = event.currentTarget.querySelector(".link");
    if (firstLink) {
      firstLink.setAttribute("data-visible", "true");
    }
  }

  onLinkLevelLeave(event) {
    if (event != null) {
      setTimeout(() => {
        const target = event.currentTarget;
       if (!target || (!target.matches?.(":hover") && !target.contains?.(document.activeElement))) {
          const firstLink = target.querySelector(".link");
          if (firstLink) {
            firstLink.setAttribute("data-visible", "false");
          }
        }
      }, 200);
    }
  }

  clearOtherVisibleLinks(currentElement) {
    this.linkLevels.forEach((linkLevel) => {
      if (linkLevel !== currentElement && !this.hasChildHovered(linkLevel)) {
        const link = linkLevel.querySelector(".link");
        if (link) {
          link.setAttribute("data-visible", "false");
        }
      }
    });
  }

  hasChildHovered(parent) {
    return Array.from(parent.querySelectorAll(".link-level")).some((child) => child.matches(":hover"));
  }
}

customElements.define("categories-menu", CategoriesMenu);
